import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _set from "lodash/set";
import _merge from "lodash/merge";
import _get from "lodash/get";
import _cloneDeep from "lodash/cloneDeep";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createAction } from 'redux-act';
import NwApiSDK from '@nerdwallet/nw-api-sdk';
import { createAsyncAction } from "./utils";
import { fetchFinancialData, transformFinancialDataProfileToLegacyDataShape } from "../utils/financial-data";
import getWebAppleTokenInfo from "./web-apple-sdk/web-apple-sdk";

var getProfiles = function getProfiles(_ref) {
  var _merge2;

  var state = _ref.state,
      profiles = _ref.profiles,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      registerImpressionId = _ref.registerImpressionId;
  var globalProfile = {
    first_name: firstName,
    last_name: lastName
  };

  var regTrackingProfile = _cloneDeep(_get(state, 'identity.tracking.trk', {}));

  if (registerImpressionId) {
    regTrackingProfile.page_impression_id = registerImpressionId;
  }

  return _merge({}, (_merge2 = {}, _defineProperty(_merge2, NwApiSDK.IDENTITY_PROFILES.GLOBAL_PROFILE, globalProfile), _defineProperty(_merge2, NwApiSDK.IDENTITY_PROFILES.REGISTRATION_TRACKING_PROFILE, regTrackingProfile), _merge2), profiles);
};
/**
 * Gets a CSRF token from identity. Typically you shouldn't have to do this and it will happen
 * automatically unless your app is only rendered client-side (e.g. the auth dialog).
 * @return {Promise}
 */


export var initClientCSRF = createAsyncAction('initClientCSRF', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.initCsrfSessionFromClient();
    }
  };
}); // *** Sign in

export var signin = createAsyncAction('signin', function (email, password, rememberMe, app, enableHeadersAndMeta) {
  return {
    meta: {
      rememberMe: rememberMe,
      enableHeadersAndMeta: enableHeadersAndMeta
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.login(app || opts.identityApp, email, password, opts.identityProfilesToInclude, rememberMe, undefined, enableHeadersAndMeta);
    },
    parseFail: function parseFail(resp) {
      if (_get(resp, 'resp.statusCode') === 429) {
        return {
          isBlocked: true
        };
      }

      return {
        signinAttemptsRemaining: _get(resp, 'data.error.data.attempts_remaining')
      };
    }
  };
});
export var generateOneTimeCookieIdTransferToken = createAsyncAction('generateOneTimeCookieIdTransferToken', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.generateOneTimeCookieIdTransferToken();
    }
  };
});
export var generateOneTimeLoginToken = createAsyncAction('generateOneTimeLoginToken', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.generateOneTimeLoginToken();
    }
  };
});
export var signinWithOneTimeToken = createAsyncAction('signinWithOneTimeToken', function (token, deviceID, rememberMe, serverRequest, app, enableHeadersAndMeta) {
  return {
    meta: {
      enableHeadersAndMeta: enableHeadersAndMeta
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.loginViaOneTimeToken(app || opts.identityApp, token, deviceID, opts.identityProfilesToInclude, rememberMe, serverRequest, enableHeadersAndMeta);
    },
    parseFail: function parseFail(resp) {
      if (_get(resp, 'resp.statusCode') === 429) {
        return {
          isBlocked: true
        };
      }

      return {
        signinAttemptsRemaining: _get(resp, 'data.error.data.attempts_remaining')
      };
    }
  };
});
/**
 * For use on the mobile app to differentiate between manual signout and fingerprint cancel /
 * auto signout after 401
 */

export var softSignout = createAction('softSignout');
/**
 * For use only on the server to update the store with the currently logged in identity. Note: for
 * this to work you need to be using `attachReactFluxIntegrationMiddlewares` server middleware from
 * nw-api-sdk. See the integration steps docs for more information.
 */

export var preloadIdentity = createAction('preloadIdentity');
export var register = createAsyncAction('register', function (email, password, firstName, lastName) {
  var profiles = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var app = arguments.length > 5 ? arguments[5] : undefined;
  var enableHeadersAndMeta = arguments.length > 6 ? arguments[6] : undefined;
  return {
    makeRequest: function makeRequest(state, opts) {
      var mergedProfiles = getProfiles({
        profiles: profiles,
        firstName: firstName,
        lastName: lastName,
        state: state,
        registerImpressionId: _get(state, 'identity.tracking.registerImpressionId')
      });
      return opts.IdentitySDK.register(app || opts.identityApp, email, password, mergedProfiles, undefined, opts.IdentitySDK.EMAIL_VERIFICATION_URLS.MY_NERDWALLET, opts.identityProfilesToInclude, undefined, enableHeadersAndMeta);
    },
    meta: {
      enableHeadersAndMeta: enableHeadersAndMeta
    }
  };
}); // Google OAuth signin based on window.gapi

var getGoogleOAuthTokenFromGapi = function getGoogleOAuthTokenFromGapi() {
  // google api not loaded so we can't make a request: fail
  if (typeof window === 'undefined' || typeof _get(window, 'gapi.auth2.getAuthInstance') !== 'function') {
    return Promise.reject();
  } // google's signin method returns a non-standard promise without a .catch() method which breaks middleware
  // wrapping it in another promise to fix this


  return new Promise(function (resolve, reject) {
    var authInstance = window.gapi.auth2.getAuthInstance();
    authInstance.signIn({
      prompt: 'select_account'
    }).then(function () {
      var googleOauthToken = authInstance.currentUser.get().getAuthResponse().id_token;
      resolve(googleOauthToken);
    }, reject);
  });
};

export var authenticateWithCorpIdp = createAsyncAction('authenticateWithCorpIdp', function () {
  var authType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'signin';
  var rememberMe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var accessToken = arguments.length > 2 ? arguments[2] : undefined;
  var clientId = arguments.length > 3 ? arguments[3] : undefined;
  var app = arguments.length > 4 ? arguments[4] : undefined;
  var enableHeadersAndMeta = arguments.length > 5 ? arguments[5] : undefined;
  return {
    meta: {
      accessToken: accessToken,
      authType: authType,
      enableHeadersAndMeta: enableHeadersAndMeta,
      rememberMe: rememberMe,
      usingPassword: false,
      usingExistingToken: false
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.loginViaCorpIdp(app || opts.identityApp, accessToken, clientId, false, // rememberMe
      undefined, // serverRequest
      true // enableHeadersAndMeta
      );
    }
  };
});
export var authenticateWithGoogle = createAsyncAction('authenticateWithGoogle', function () {
  var authType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'signin';
  var rememberMe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var password = arguments.length > 2 ? arguments[2] : undefined;
  var app = arguments.length > 3 ? arguments[3] : undefined;
  var profiles = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var token = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var enableHeadersAndMeta = arguments.length > 6 ? arguments[6] : undefined;
  return {
    meta: {
      authType: authType,
      rememberMe: rememberMe,
      usingPassword: !!password,
      usingExistingToken: !!token,
      enableHeadersAndMeta: enableHeadersAndMeta
    },
    makeRequest: function makeRequest(state, opts) {
      var mergedProfiles = getProfiles({
        profiles: profiles,
        state: state
      }); // by default use getGoogleOAuthTokenFromGapi to get the token

      var getGoogleOAuthToken = getGoogleOAuthTokenFromGapi; // if a token is explicitly passed use that. Resolved promise here so interface matches getGoogleOAuthTokenFromGapi

      if (token) getGoogleOAuthToken = function getGoogleOAuthToken() {
        return Promise.resolve(token);
      }; // or if there is an option `getGoogleOAuthToken` use that (typically used by mobile app).
      else if (opts.getGoogleOAuthToken) {
          getGoogleOAuthToken = opts.getGoogleOAuthToken;
        }
      return getGoogleOAuthToken({
        usingPassword: !!password
      }).then(function (googleOAuthToken) {
        return opts.IdentitySDK.loginViaGoogle(app || opts.identityApp, googleOAuthToken, opts.identityProfilesToInclude, mergedProfiles, rememberMe, password, undefined, enableHeadersAndMeta);
      });
    }
  };
});
export var authenticateWithApple = createAsyncAction('authenticateWithApple', function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$authType = _ref2.authType,
      authType = _ref2$authType === void 0 ? 'signin' : _ref2$authType,
      _ref2$rememberMe = _ref2.rememberMe,
      rememberMe = _ref2$rememberMe === void 0 ? true : _ref2$rememberMe,
      password = _ref2.password,
      app = _ref2.app,
      profiles = _ref2.profiles,
      enableHeadersAndMeta = _ref2.enableHeadersAndMeta;

  return {
    meta: {
      authType: authType,
      rememberMe: rememberMe,
      enableHeadersAndMeta: enableHeadersAndMeta,
      usingPassword: !!password
    },
    makeRequest: function makeRequest(state, opts) {
      var mergedProfiles = getProfiles({
        profiles: profiles,
        state: state
      });
      var getAppleTokenInfo = opts.getAppleTokenInfo ? opts.getAppleTokenInfo // used by Native
      : getWebAppleTokenInfo; // "email" and "code" are only set if user had just failed Apple Auth

      var email = _get(state, 'identity.temp.email');

      var code = _get(state, 'identity.temp.code');

      return getAppleTokenInfo({
        usingPassword: !!password,
        email: email,
        code: code
      }).then(function (response) {
        return new Promise(function (resolve, reject) {
          return opts.IdentitySDK.loginViaApple({
            app: app || opts.identityApp,
            clientId: opts.appleSigninClientId,
            nonce: _get(response, 'nonce'),
            authorizationCode: _get(response, 'code'),
            redirectUri: _get(response, 'redirect_uri'),
            firstName: _get(response, 'user.name.firstName'),
            lastName: _get(response, 'user.name.lastName'),
            email: _get(response, 'user.email'),
            includeProfiles: opts.identityProfilesToInclude,
            profilesIfReg: mergedProfiles,
            rememberMe: rememberMe,
            password: password,
            enableHeadersAndMeta: enableHeadersAndMeta
          }).then(resolve)["catch"](function (err) {
            return (// Append "temp" values to payload so they can be persisted in Redux
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(_objectSpread(_objectSpread({}, err), {}, {
                temp: {
                  email: _get(response, 'user.email'),
                  code: _get(response, 'code')
                }
              }))
            );
          });
        });
      });
    }
  };
});
export var signinWithRefreshToken = createAsyncAction('signinWithRefreshToken', function (refreshToken) {
  var rememberMe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var app = arguments.length > 2 ? arguments[2] : undefined;
  var enableHeadersAndMeta = arguments.length > 3 ? arguments[3] : undefined;
  return {
    meta: {
      enableHeadersAndMeta: enableHeadersAndMeta
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.loginViaRefreshToken(app || opts.identityApp, refreshToken, opts.identityProfilesToInclude, rememberMe, enableHeadersAndMeta);
    }
  };
}); // *** Signout

export var signout = createAsyncAction('signout', function (serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.logout(serverRequest);
    }
  };
}); // *** Request identity

export var requestIdentity = createAsyncAction('requestIdentity',
/**
 * @param serverRequest {Object} - if called from the server, include the request so we can properly propagate headers
 * @param profilesToExclude {string[]} - by default, requestIdentity wholly replaces all profiles in the redux store
 * with .profiles from the AJAX response. However, the JSON response returns a `null` for all possible profiles that
 * are not requested. Use this field if you want to manage profiles outside of the requestIdentityAction, otherwise
 * the profile's value in the redux store will be set to `null` each time `requestIdentity` is invoked.
 */
function (serverRequest, profilesToExclude) {
  return {
    makeRequest: function () {
      var _makeRequest = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(_state, _ref3) {
        var apolloClient, identityProfilesToInclude, IdentitySDK, _ref4, _ref5, identityData, financialData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apolloClient = _ref3.apolloClient, identityProfilesToInclude = _ref3.identityProfilesToInclude, IdentitySDK = _ref3.IdentitySDK;

                if (identityProfilesToInclude.includes(NwApiSDK.IDENTITY_PROFILES.YODLEE_PROFILE)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", IdentitySDK.getLoggedInIdentity(identityProfilesToInclude, serverRequest));

              case 3:
                _context.next = 5;
                return Promise.all([IdentitySDK.getLoggedInIdentity(identityProfilesToInclude, serverRequest), fetchFinancialData(apolloClient)]);

              case 5:
                _ref4 = _context.sent;
                _ref5 = _slicedToArray(_ref4, 2);
                identityData = _ref5[0];
                financialData = _ref5[1];

                _set(identityData, 'identity.profiles.yodlee_profile', transformFinancialDataProfileToLegacyDataShape(financialData));

                return _context.abrupt("return", identityData);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function makeRequest(_x, _x2) {
        return _makeRequest.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      profilesToExclude: profilesToExclude
    }
  };
});
export var resetPassword = createAsyncAction('resetPassword', function (password, resetToken, challengeAnswer, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return new Promise(function (resolve, reject) {
        return opts.IdentitySDK.resetPassword(resetToken, password, challengeAnswer, serverRequest).then(resolve)["catch"](function (err) {
          var message = _get(err, 'data.error.data.fields.password[0].user_message'); // If the failure is because they are trying to change their password to their old password, let's
          // just tell them it's right since they know their password needed to login.
          // returning makes the promise resolve and will dispatch success action


          if (message === 'New password must be different from old password.') {
            return resolve();
          } // otherwise throw an error so it is a failure


          reject(err);
        });
      });
    }
  };
});
export var updatePassword = createAsyncAction('updatePassword', function (oldPassword, newPassword) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.updatePassword(oldPassword, newPassword);
    }
  };
});
export var deactivateUser = createAsyncAction('deactivateUser', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.deactivate();
    }
  };
});
export var createPassword = createAsyncAction('createPassword', function (password) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.createPassword(password);
    }
  };
});
export var getSecurityQuestions = createAsyncAction('getSecurityQuestions', function (serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.getSecurityQuestions(serverRequest);
    }
  };
});
export var setSecurityQuestion = createAsyncAction('setSecurityQuestion', function (question, answer) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.setSecurityChallenge(question, answer);
    }
  };
});
export var createTUCustomer = createAsyncAction('createTUCustomer', function (customer, trustSessionId) {
  return {
    meta: {
      isFullSSN: !!customer.full_ssn
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.TUCreditReport.createCustomer(_objectSpread(_objectSpread({}, customer), {}, {
        trust_session_id: trustSessionId
      }));
    },
    parseSuccess: function parseSuccess(resp) {
      return {
        profile: resp
      };
    },
    parseFail: function parseFail(resp) {
      return _get(resp, 'data.error.data', {});
    }
  };
});
export var setTUAuthentication = createAsyncAction('setTUAuthentication', function (answers) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.TUCreditReport.authenticateCustomer(answers);
    }
  };
});
export var enrollTUCustomer = createAsyncAction('enrollTUCustomer', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.TUCreditReport.enrollCustomer();
    }
  };
});
export var deactivateUserViaToken = createAsyncAction('deactivateUserViaToken', function (deactivateToken) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.deactivateViaToken(deactivateToken);
    }
  };
});
export var refreshTUCreditProfile = createAsyncAction('refreshTUCreditProfile', function (shouldPurge) {
  return {
    meta: {
      shouldPurge: shouldPurge
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.TUCreditReport.refreshTUCreditProfile();
    }
  };
});
export var deactivateTUCustomer = createAsyncAction('deactivateTUCustomer', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.TUCreditReport.deactivateCustomer();
    }
  };
});
export var lookupSecurityChallenge = createAsyncAction('lookupSecurityChallenge', function (token, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.lookupSecurityChallenge(token, serverRequest);
    }
  };
});
export var requestOtpSecret = createAsyncAction('requestOtpSecret', function (password, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.requestOtpSecret(password, serverRequest);
    }
  };
});
export var deactivateOtp = createAsyncAction('deactivateOtp', function (otpCode, serverRequest) {
  return {
    meta: {
      otpCode: otpCode
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.deactivateOtp(otpCode, serverRequest);
    }
  };
});
export var verifyOtpCode = createAsyncAction('verifyOtpCode', function (otpCode, serverRequest) {
  return {
    meta: {
      otpCode: otpCode
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.verifyOtpCode(otpCode, serverRequest);
    }
  };
});
export var generateOtpBackupCodes = createAsyncAction('generateOtpBackupCodes', function (otpCode, serverRequest) {
  return {
    meta: {
      otpCode: otpCode
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.generateOtpBackupCodes(otpCode, serverRequest);
    }
  };
});
export var acknowledgeTOS = createAsyncAction('acknowledgeTOS', function (type, source, version, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.acknowledgeTOS(type, source, version, serverRequest);
    },
    meta: {
      tosEntry: {
        type: type,
        source: source,
        version: version
      }
    }
  };
});
export var restartTUFlow = createAction('restartTUFlow');
export var saveRegisterImpression = createAction('saveRegisterImpression');